import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_LINK;

export const getTickets = async (params = {}) => {
    try {
        const { status, priority } = params;

        const response = await axios.post(API_URL, {
            method: "support",
            submethod: "getallhistory",
            status,
            priority,
            key: process.env.REACT_APP_KEY
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching tickets:', error);
        throw error;
    }
};


export const getTicketMessages = async (ticketId) => {
    try {

        const response = await axios.post(API_URL, {
            method: "support",
            submethod: "getmsghistory",
            userAddress: "admin",
            role: "admin",
            ticketId,
            key: process.env.REACT_APP_KEY
        });

        return response.data.messages;
    } catch (error) {
        console.error("Error fetching messages:", error);
        throw error;
    }
};


/**
 * Update the status of a ticket
 * @param {string} ticketId 
 * @param {string} status - 'open' | 'in-progress' | 'closed'
 */
export const updateTicketStatus = async (ticketId, status) => {
    try {
        const response = await axios.post(API_URL, {
            method: "support",
            submethod: "updatetickt",
            ticketId,
            status,
            key: process.env.REACT_APP_KEY
        });

        return response.data;
    } catch (error) {
        console.error("Error updating ticket status:", error);
        throw error;
    }
};

export const sendMessage = async (ticketId, content, image) => {
    try {

        const response = await axios.post(API_URL, {
            method: "support",
            submethod: "sendmsg",
            ticketId,
            userAddress: "admin",
            role: "admin",
            content,
            image,
            key: process.env.REACT_APP_KEY
        });

        return response.data.newMessage;
    } catch (error) {
        console.error("Error sending message:", error);
        throw error;
    }
};